import { styled } from '@mui/material/styles';
import PlusSymbolSvg from 'mui/assets/icons/plus-symbol.svg';
import MinusSymbolSvg from 'mui/assets/icons/minus-symbol.svg';
import { DS_typography as coreTypography } from '../../../base/theme/DS_Tokens/core';

export const StyledMap = styled('div')(
  ({ zoomControls, fullView, theme }) => `
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: inherit;
    
    .mapboxgl-ctrl-compass, .mapboxgl-compact, .mapboxgl-ctrl-attrib {
      display: none;
    }
    .mapboxgl-control-container {
      position: absolute;
      right: 0;
      top: 45%;
    }
    .mapboxgl-control-container ~ div > h1 {
      font-size: 18px !important;
      font-family: ${coreTypography.fontFamily.default} !important;
      top: 40% !important;
    }
    .mapboxgl-ctrl-group {
      border: 0;
      background: none;
      box-shadow: none !important;
    }
    .mapboxgl-ctrl-zoom-in, .mapboxgl-ctrl-zoom-out {
      display: ${zoomControls ? `block` : `none`};
      width: 40px;
      height: 40px;
      padding: 10px;
      border-radius: 12px !important;
      background-color: ${theme.DS_palette.primary.white} !important;
      box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07);
      border: 0;
    }
    .mapboxgl-ctrl-zoom-in {
      margin-bottom: ${theme.DS_spacing(['xxs'])};
      
      span {
        background-image: url(${PlusSymbolSvg}) !important;
      }
    }
    .mapboxgl-ctrl-zoom-out {
      span {
        background-image: url(${MinusSymbolSvg}) !important;
      }
    }
    
    // map info window style
    .woosmap-map-pane {
      > div:first-child {
        border-radius: 12px !important;
        box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07) !important;
        
        > span:first-child {
          top: 2px !important;
          right: 2px !important;
          font-size: 20px !important;
        }
        > div {
          padding: 0 !important;
          max-height: unset !important;
          
          a {
            background-color: ${theme.DS_palette.buttons.enabled} !important;
          }
        }
      }
    }
    
    ${theme.breakpoints.up('md')} {
      .mapboxgl-control-container {
        top: 41%;
      }
    }
    ${theme.breakpoints.up('lg')} {
      .mapboxgl-control-container {
        top: ${fullView ? 'auto' : '83%'};
        bottom: ${fullView ? '22%' : 'auto'};
      }
      .mapboxgl-control-container ~ div > h1 {
        left: ${fullView ? `auto` : `76% !important`};
      }
    }
  `,
);
